var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BasicHeader',{attrs:{"image":require('/src/assets/img/home/abc_banner-min.png')}}),_c('login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }